import { render, staticRenderFns } from "./R2.vue?vue&type=template&id=293316a4&scoped=true&"
import script from "./R2.vue?vue&type=script&lang=js&"
export * from "./R2.vue?vue&type=script&lang=js&"
import style0 from "./R2.vue?vue&type=style&index=0&id=293316a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293316a4",
  null
  
)

export default component.exports